"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _intl = require("@kyruus/intl");
var _providerComponents = require("@kyruus/provider-components");
var _styles = _interopRequireDefault(require("./styles"));
const ProviderBadge = _ref => {
  let {
    intl,
    badge
  } = _ref;
  let label;
  let field;
  let color = 'default';
  if (typeof badge === 'string') {
    field = badge;
  } else {
    ({
      label,
      field,
      color = color
    } = badge);
  }
  const badgeText = _react.default.useMemo(() => {
    return label || intl.formatMessage({
      id: `provider.badge.${field}`,
      defaultMessage: (0, _providerComponents.formatBadgeText)(field),
      description: 'Badge text for the specified field'
    });
  }, [intl, label, field]);
  return /*#__PURE__*/_react.default.createElement(_styles.default, {
    color: color,
    "data-testid": `badge_chip_${field}`,
    label: badgeText,
    size: "small"
  });
};
var _default = exports.default = (0, _intl.injectIntl)(ProviderBadge);
ProviderBadge.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProviderBadge"
};